/** Money as the API sends it: integer minor units plus an ISO 4217 code. */
export interface Money {
  minor: number;
  currency: string;
}

const exponents: Record<string, number> = {
  JPY: 0,
  KRW: 0,
  VND: 0,
  ISK: 0,
  CLP: 0,
  BHD: 3,
  KWD: 3,
  JOD: 3,
  OMR: 3,
  TND: 3,
};

export function exponentOf(currency: string): number {
  return exponents[currency] ?? 2;
}

export function toMajor(money: Money): number {
  return money.minor / 10 ** exponentOf(money.currency);
}

export function formatMoney(money: Money, locale = "en-CA"): string {
  return new Intl.NumberFormat(locale, { style: "currency", currency: money.currency }).format(
    toMajor(money),
  );
}

/** Parse user input such as "19.99" into minor units, rounding half up. Returns null when invalid. */
export function parseMoney(input: string, currency: string): Money | null {
  const cleaned = input.replace(/[^0-9.-]/g, "");
  if (cleaned === "" || cleaned === "-" || cleaned === "." || !/^-?\d*(\.\d*)?$/.test(cleaned)) {
    return null;
  }
  const factor = 10 ** exponentOf(currency);
  const minor = Math.round((Number(cleaned) + Number.EPSILON) * factor);
  return { minor, currency };
}
